import {useState, useRef} from "../../_snowpack/pkg/react.js";
const useInput = (type) => {
  const [value, setValue] = useState("");
  const ref = useRef(null);
  const onChange = (event) => {
    event.preventDefault();
    setValue(event.target.value);
  };
  return {
    value,
    setValue,
    type,
    ref,
    onChange
  };
};
export default useInput;
